import { render } from "./Heart.vue?vue&type=template&id=f18524be&scoped=true"
import script from "./Heart.vue?vue&type=script&lang=js"
export * from "./Heart.vue?vue&type=script&lang=js"

import "./Heart.vue?vue&type=style&index=0&id=f18524be&scoped=true&lang=css"

import exportComponent from "D:\\My Project\\NewBlog\\WEB\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f18524be"]])

export default __exports__